// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// VERIFIACTION DETAILS ADD FUNCTION
export const verificationDetailsAdd = (verificationData: any) => {
	const data = {
		AddBusinessTokenVerification: verificationData,
	};
	const url = `${API_URL}addBusinessVerification`;
	return makeApiCall(url, data);
};

// FECTH VERIFIACTION DETAILS FUNCTIOON
export const fetchVerificationDetails = (fetchData: any) => {
	const data = {
		GetBusinessTokenVerify: fetchData,
	};
	const url = `${API_URL}getBusinessVerification`;
	return makeApiCall(url, data);
};

// UPDATE VERIFICATION DETAILS FUNCTION
export const updateVerificationDetails = (updateData: any) => {
	const data = {
		UpdateVerificationDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessVerification`;
	return makeApiCall(url, data);
};

// DELETE VERIFICATION DETAILS FUNCTION
export const deleteVerificationDetails = (deleteData: any) => {
	const data = {
		DeleteBusinessVerificationDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessVerification`;
	return makeApiCall(url, data);
};
